export default __webpack_public_path__ + "static/media/02.89ccd8f6.jpg";